import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IReportResponse } from '../Shared/model/ReportsModel';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})

export class ReportsService {
  private baseURL: string;
  constructor(private http: HttpClient,private pipe: DatePipe) {
    this.baseURL = environment.apiBaseUrl;
  }

  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  generateReport(ReportRequestModel: any): Observable<IReportResponse> {
    this.pipe = new DatePipe('en-US');
    let pdate = this.pipe.transform(new Date(), 'yyyy-MM-dd');
    let ptime = this.pipe.transform(new Date(), 'HH:mm:ss');
    ReportRequestModel["PrintedDate"] = pdate + 'T' + ptime;
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    const url = `${this.baseURL}/Reports/GenerateReport`;
    return this.http.post<IReportResponse>(url, ReportRequestModel, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    console.error('server error:', error);
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }
    return throwError(error || 'Node.js server error');
  }

  getVendorColumnDescriptions(): Observable<any[]> {
    return this.http.get<any>(
      `${this.baseURL}/Reports/GetVendorColumnDescription`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const formats = res.body as any;
          return formats;
        }),
        catchError(this.handleError)
      );
  }

  GetDesignVendorReportsData(model): Observable<any> {
    const options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    return this.http.post<any>(
      `${this.baseURL}/Reports/GetDesignVendorReportsData`, model, options)
      .pipe(
        map(res => {
          return res;
        }),
        catchError(this.handleError)
      );
  }
}
